module.exports = __webpack_public_path__ + "img/img-i5gam-tab3.b8fda9de.png";